function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { worldViewerWindow } from '../const';
export class CChannelSessionApi {
    startHeartbeat() {
        this.m_HeartbeatObserveInterval = setInterval(async ()=>{
            const resHeartbeat = await worldViewerWindow.heliport.v3.api.channelSessionApi.refreshChannelSession();
            worldViewerWindow.hel_SetServerTime(resHeartbeat.data.response_timestamp);
        }, this.m_HeartbeatSendSpan);
    }
    stopHeartbeat() {
        if (this.m_HeartbeatObserveInterval) {
            clearInterval(this.m_HeartbeatObserveInterval);
        }
    }
    // コンストラクタ
    constructor(){
        _defineProperty(this, "m_HeartbeatSendSpan", 30000);
        _defineProperty(this, "m_HeartbeatObserveInterval", void 0);
        this.m_HeartbeatObserveInterval = null;
    }
}
